const state = () => ({
    installations: [],
})

const getters = {}

const actions = {
    async fetchInstallations({commit}) {
        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_app_installation'))
        const list = res?.data?.data ?? []
        commit('setInstallations', list)
        return list
    },
    async showApp(_, {key}) {
        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_app_installation') + '/' + key)
        return res?.data?.data
    },
    async saveApp(_, {key, data}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_app_installation') + '/' + key, data)
        return res?.data
    },
    async uninstallApp(_, {key}) {
        const res = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_app_installation') + '/' + key)
        return res?.data
    },
}

const mutations = {
    setInstallations(state, list) {
        state.installations = list
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
